import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'priorityTime',
})
export class PriorityTimePipe implements PipeTransform {
    transform(value: number) {
        if (value == null) {
            return '';
        }

        switch (value) {
            case 1:
                return '24 hours (1 staff work day)';
            case 2:
                return '2 staff workdays';
            case 3:
                return '5 staff workdays';
            default:
                return '';
        }
    }
}
